import { IFundDataModel } from '../../../../../data-models/fund.data-model';
import { IMetricsDataModel } from '../../../../../data-models/metrics.data-model';

// FD-3283: the Fund (external) filter predicate. A company row passes when one
// of its transactions belongs to a selected fund. Null filteredFunds = no
// filter (all rows pass); an empty array selects no funds (no rows pass).
export function companyPassesFundFilter(
  data: Pick<IMetricsDataModel, 'transactions'> | undefined | null,
  filteredFunds: IFundDataModel[] | null
): boolean {
  if (!data) {
    return false;
  }
  if (filteredFunds == null) {
    return true;
  }

  const fundIds = new Set<number>();
  for (const t of data.transactions ?? []) {
    if (t.fundId != null) {
      fundIds.add(t.fundId);
    }
  }
  return filteredFunds.some((f) => fundIds.has(f.id));
}
